module.exports = __webpack_public_path__ + "img/block_1.49438708.webp";